"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAutoType = void 0;
var getAutoType = function (map, typeArray) {
    if (map.size === typeArray.length) {
        map.clear();
    }
    var index = ~~(Math.random() * 4);
    while (map.has(typeArray[index])) {
        index = ~~(Math.random() * 4);
    }
    map.set(typeArray[index], true);
    return typeArray[index];
};
exports.getAutoType = getAutoType;
